import { ref } from 'vue';
import { defineStore } from 'pinia';
import { ISiteCards } from '@/types/ISiteCards';

export const useSearchStore = defineStore(
  'searchStore',
  () => {
    const url = ref<string | null>(null);
    const key = ref<string | null>(null);
    const redirectUrl = ref<string | null>(null);
    const owningSite = ref<string | null>(null);
    const randomSites = ref<ISiteCards>();

    const setUrl = (newUrl: string) => {
      url.value = newUrl;
    };

    const setKey = (newKey: string) => {
      key.value = newKey;
    };

    const setRedirectUrl = (newUrl: string) => {
      redirectUrl.value = newUrl;
    };

    const setOwningSite = (newUrl: string) => {
      owningSite.value = newUrl;
    };

    const setRandomSites = (data: ISiteCards) => {
      randomSites.value = data;
    };

    const getUrl = (): string | null => {
      return url.value;
    };

    const getKey = (): string | null => {
      return key.value;
    };

    const getRedirectUrl = (): string | null => {
      return redirectUrl.value;
    };

    const getRandomSites = (): ISiteCards => {
      return randomSites.value!;
    };

    return {
      url,
      key,
      redirectUrl,
      setUrl,
      setKey,
      setRedirectUrl,
      getUrl,
      getKey,
      getRedirectUrl,
      owningSite,
      setOwningSite,
      randomSites,
      setRandomSites,
      getRandomSites,
    };
  });
